let doit = null;
const containerMessage = document.getElementById('containerMessage');

const adjust = () => {
  const container = document.getElementById('container');
  const mainvisual = document.getElementById('mainvisual');
  const wW = window.innerWidth;
  const texts = document.getElementById('texts');

  clearTimeout(doit);

  doit = setTimeout(() => {
    container.style.height = mainvisual.clientHeight - 20 + 'px';

    if (wW <= 767) {
      container.style.marginBottom = texts.clientHeight + 'px';
    } else {
      container.style.marginBottom = '70px';
    }
  }, 200);
};

window.addEventListener('DOMContentLoaded', adjust, false);
window.addEventListener('resize', adjust, false);
